import apiClient from "../../utils/interceptor";
import { API_URLS } from "../../constants";

// Get all companies
export const getAllCompanies = async () => {
    try {
        const response = await apiClient.get(
            API_URLS.COMPANY.GET_COMPANIES
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching companies:", error);
        throw error;
    }
};

// Create company
export const createCompany = async (companyParams) => {
    try {
        const response = await apiClient.post(
            API_URLS.COMPANY.CREATE_COMPANY,
            companyParams
        );
        return response.data;
    } catch (error) {
        console.error("Error creating company:", error);
        throw error;
    }
};

// Update company
export const updateCompany = async (companyData) => {
    try {
        const response = await apiClient.patch(
            API_URLS.COMPANY.UPDATE_COMPANY,
            companyData
        );
        return response.data;
    } catch (error) {
        console.error("Error updating company:", error);
        throw error;
    }
};

// Delete company
export const deleteCompany = async (companyId) => {
    try {
        const response = await apiClient.delete(
            API_URLS.COMPANY.DELETE_COMPANY,
            {
                data: { company_id: companyId },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting company:", error);
        throw error;
    }
};

export const downloadCompanyScanImages = async ({ companyId, startDate, endDate, yard_ids, user_ids }) => {
    try {
        const response = await apiClient.post(
            API_URLS.COMPANY.DOWNLOAD_COMPANY_IMAGES,
            {
                company_id: companyId,
                start_date: startDate,
                end_date: endDate,
                yard_ids: yard_ids,
                user_ids: user_ids,
            },
            {
                responseType: "blob",
            }
        );
        return response;
    } catch (error) {
        if (error.response?.data instanceof Blob) {
            const text = await error.response.data.text();
            try {
                const json = JSON.parse(text);
                error.response.data = json;
            } catch {
                
            }
        }
        console.error("Error downloading company scan images:", error);
        throw error;

    }
};

export const getAssetTypes = async () => {
  try {
    const response = await apiClient.get(
      API_URLS.COMPANY.GET_ASSET_TYPES
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching asset types:", error);
    throw error;
  }
};